import { render, staticRenderFns } from "./MonthParkingInvoice.vue?vue&type=template&id=67dd153c&scoped=true"
import script from "./MonthParkingInvoice.vue?vue&type=script&lang=js"
export * from "./MonthParkingInvoice.vue?vue&type=script&lang=js"
import style0 from "./MonthParkingInvoice.vue?vue&type=style&index=0&id=67dd153c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd153c",
  null
  
)

export default component.exports